import { mockResponse } from '@/utils/format'

const months = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']

const STANDARDS = ['GB/T 32150', 'ISO 14064-1', 'GHG Protocol']

export function getHomeData() {
  return mockResponse({
    standards: STANDARDS,
    year: 2025,
    annualStats: {
      carbonEmission: { value: 13897.8659, unit: 'tCO2e', yoy: 0 },
      energyConsumption: { value: 5950.7096, unit: 'tce', yoy: 0 }
    },
    monthlyTrend: {
      months,
      fuelCombustion: [320, 280, 350, 310, 340, 360, 380, 370, 350, 330, 340, 360],
      purchasedEnergy: [180, 160, 200, 190, 210, 220, 230, 225, 215, 200, 210, 220],
      processEmission: [450, 420, 480, 460, 490, 500, 520, 510, 495, 480, 490, 505],
      totalEmission: [950, 860, 1030, 960, 1040, 1080, 1130, 1105, 1060, 1010, 1040, 1085]
    },
    carbonFlowSankey: {
      nodes: [
        { name: '天然气' },
        { name: '净购入电力' },
        { name: '煤炭' },
        { name: '柴油' },
        { name: '蒸汽' },
        { name: '化石燃料燃烧' },
        { name: '净购入电热' }
      ],
      links: [
        { source: '天然气', target: '化石燃料燃烧', value: 3200 },
        { source: '煤炭', target: '化石燃料燃烧', value: 2800 },
        { source: '柴油', target: '化石燃料燃烧', value: 1500 },
        { source: '净购入电力', target: '净购入电热', value: 4200 },
        { source: '蒸汽', target: '净购入电热', value: 1800 }
      ]
    },
    reductionAnalysis: {
      categories: ['自发绿电', '外购绿电', '碳汇'],
      quantity: [185000, 95000, 0],
      reduction: [85000, 42000, 15000]
    }
  })
}

export function getBoundaryData(params = {}) {
  const year = params.year || '2025'
  const standard = params.standard || 'GB/T 32150'

  return mockResponse({
    standards: STANDARDS,
    year,
    standard,
    summary: {
      facilityCount: { today: 12, annual: 12, unit: '个' },
      sourceCount: { today: 28, annual: 28, unit: '个' },
      confirmedCount: { today: 10, annual: 10, unit: '个' }
    },
    orgTree: [
      {
        id: 'org-1',
        label: 'DST 碳排放管理集团',
        children: [
          {
            id: 'plant-1',
            label: '一号生产基地',
            children: [
              { id: 'fac-1', label: '锅炉房' },
              { id: 'fac-2', label: '自备电厂' },
              { id: 'fac-3', label: '生产车间 A' },
              { id: 'fac-4', label: '生产车间 B' }
            ]
          },
          {
            id: 'plant-2',
            label: '二号生产基地',
            children: [
              { id: 'fac-5', label: '燃气锅炉站' },
              { id: 'fac-6', label: '空压站' },
              { id: 'fac-7', label: '仓储物流中心' }
            ]
          }
        ]
      }
    ],
    currentNodeId: 'plant-1',
    orgBoundary: {
      method: '运营控制法',
      equityRatio: '100%',
      effectiveDate: `${year}-01-01`,
      standard,
      description: '纳入集团全资及控股子公司的全部生产运营设施，按运营控制边界确定组织边界。'
    },
    emissionSources: [
      { id: 1, name: '天然气锅炉燃烧', scope: 'Scope 1', category: '化石燃料燃烧', facility: '锅炉房', status: 'confirmed', statusLabel: '已确认' },
      { id: 2, name: '煤炭燃烧', scope: 'Scope 1', category: '化石燃料燃烧', facility: '自备电厂', status: 'confirmed', statusLabel: '已确认' },
      { id: 3, name: '柴油发电机', scope: 'Scope 1', category: '化石燃料燃烧', facility: '生产车间 A', status: 'confirmed', statusLabel: '已确认' },
      { id: 4, name: '工业过程排放', scope: 'Scope 1', category: '过程排放', facility: '生产车间 B', status: 'confirmed', statusLabel: '已确认' },
      { id: 5, name: '净购入电力', scope: 'Scope 2', category: '净购入电热', facility: '一号生产基地', status: 'confirmed', statusLabel: '已确认' },
      { id: 6, name: '净购入蒸汽', scope: 'Scope 2', category: '净购入电热', facility: '一号生产基地', status: 'confirmed', statusLabel: '已确认' },
      { id: 7, name: '燃气锅炉燃烧', scope: 'Scope 1', category: '化石燃料燃烧', facility: '燃气锅炉站', status: 'confirmed', statusLabel: '已确认' },
      { id: 8, name: '员工通勤', scope: 'Scope 3', category: '其他间接排放', facility: '集团总部', status: 'draft', statusLabel: '草稿' },
      { id: 9, name: '外购原材料运输', scope: 'Scope 3', category: '其他间接排放', facility: '仓储物流中心', status: 'draft', statusLabel: '草稿' }
    ],
    facilities: [
      { id: 1, name: '锅炉房', plant: '一号生产基地', included: true, reason: '主要固定燃烧排放源' },
      { id: 2, name: '自备电厂', plant: '一号生产基地', included: true, reason: '化石燃料燃烧及电力生产' },
      { id: 3, name: '生产车间 A', plant: '一号生产基地', included: true, reason: '含过程排放与移动源' },
      { id: 4, name: '生产车间 B', plant: '一号生产基地', included: true, reason: '工业过程排放' },
      { id: 5, name: '燃气锅炉站', plant: '二号生产基地', included: true, reason: '天然气燃烧排放' },
      { id: 6, name: '空压站', plant: '二号生产基地', included: true, reason: '电力间接排放关联设施' },
      { id: 7, name: '仓储物流中心', plant: '二号生产基地', included: false, reason: '暂不具备完整活动数据' }
    ],
    scopeOptions: ['Scope 1', 'Scope 2', 'Scope 3'],
    categoryOptions: ['化石燃料燃烧', '净购入电热', '过程排放', '其他间接排放'],
    statusOptions: [
      { value: 'draft', label: '草稿' },
      { value: 'confirmed', label: '已确认' }
    ]
  })
}

export function getDatabaseData(params = {}) {
  const keyword = (params.keyword || '').trim()
  const category = params.category || ''
  const source = params.source || ''

  const emissionFactors = [
    { id: 1, name: '天然气燃烧', category: '化石燃料燃烧', unit: 'tCO2/万m³', value: 21.622, source: 'GB/T 32150 附录B', year: 2025, refCount: 156 },
    { id: 2, name: '煤炭燃烧（一般烟煤）', category: '化石燃料燃烧', unit: 'tCO2/t', value: 1.9003, source: 'GB/T 32150 附录B', year: 2025, refCount: 142 },
    { id: 3, name: '柴油燃烧', category: '化石燃料燃烧', unit: 'tCO2/t', value: 3.0959, source: 'GB/T 32150 附录B', year: 2025, refCount: 38 },
    { id: 4, name: '净购入电力（华东电网）', category: '净购入电热', unit: 'tCO2/MWh', value: 0.5810, source: '生态环境部 2022', year: 2025, refCount: 210 },
    { id: 5, name: '净购入蒸汽', category: '净购入电热', unit: 'tCO2/GJ', value: 0.1100, source: 'GB/T 32150 附录B', year: 2025, refCount: 65 },
    { id: 6, name: '石灰石分解', category: '过程排放', unit: 'tCO2/t', value: 0.4400, source: 'IPCC 2006', year: 2024, refCount: 28 }
  ]

  const gwpValues = [
    { id: 1, gas: 'CO₂', gwp: 1, version: 'AR5', standard: 'IPCC AR5', year: 2025 },
    { id: 2, gas: 'CH₄', gwp: 28, version: 'AR5', standard: 'IPCC AR5', year: 2025 },
    { id: 3, gas: 'N₂O', gwp: 265, version: 'AR5', standard: 'IPCC AR5', year: 2025 },
    { id: 4, gas: 'HFC-134a', gwp: 1300, version: 'AR5', standard: 'IPCC AR5', year: 2025 },
    { id: 5, gas: 'SF₆', gwp: 23500, version: 'AR5', standard: 'IPCC AR5', year: 2025 }
  ]

  const heatingValues = [
    { id: 1, energyType: '天然气', lowerHeatingValue: 389.31, unit: 'GJ/万m³', coefficient: 13.3, year: 2025 },
    { id: 2, energyType: '一般烟煤', lowerHeatingValue: 20.908, unit: 'GJ/t', coefficient: 0.7143, year: 2025 },
    { id: 3, energyType: '柴油', lowerHeatingValue: 42.652, unit: 'GJ/t', coefficient: 1.4571, year: 2025 },
    { id: 4, energyType: '电力', lowerHeatingValue: 3.6, unit: 'GJ/MWh', coefficient: 0.1229, year: 2025 },
    { id: 5, energyType: '蒸汽', lowerHeatingValue: 2.742, unit: 'GJ/t', coefficient: 0.0936, year: 2025 }
  ]

  const filterFactors = emissionFactors.filter(item => {
    if (category && item.category !== category) return false
    if (source && !item.source.includes(source)) return false
    if (keyword && !item.name.includes(keyword)) return false
    return true
  })

  return mockResponse({
    categories: ['化石燃料燃烧', '净购入电热', '过程排放', '其他间接排放'],
    sources: ['GB/T 32150 附录B', '生态环境部 2022', 'IPCC 2006', 'IPCC AR5'],
    summary: {
      totalFactors: { today: emissionFactors.length, annual: emissionFactors.length, unit: '条' },
      updatedThisYear: { today: 5, annual: 5, unit: '条' },
      totalRefs: { today: 639, annual: 639, unit: '次' }
    },
    emissionFactors: filterFactors,
    gwpValues,
    heatingValues
  })
}

export function getReportData(params = {}) {
  const year = params.year || ''
  const standard = params.standard || ''
  const status = params.status || ''

  const reports = [
    {
      id: 1,
      name: '2025年度温室气体排放盘查报告',
      year: 2025,
      standard: 'GB/T 32150',
      boundaryVersion: 'V2025.1',
      totalEmission: 13897.8659,
      status: 'published',
      statusLabel: '已发布',
      createTime: '2025-03-15 10:30:00',
      scopeBreakdown: [
        { scope: 'Scope 1', emission: 7500.3200, ratio: 53.97 },
        { scope: 'Scope 2', emission: 6000.5459, ratio: 43.17 },
        { scope: 'Scope 3', emission: 397.0000, ratio: 2.86 }
      ],
      topSources: [
        { name: '净购入电力', emission: 4200.0000, ratio: 30.22 },
        { name: '煤炭燃烧', emission: 2800.0000, ratio: 20.15 },
        { name: '天然气锅炉燃烧', emission: 3200.0000, ratio: 23.03 },
        { name: '工业过程排放', emission: 1500.3200, ratio: 10.80 },
        { name: '净购入蒸汽', emission: 1800.5459, ratio: 12.96 }
      ]
    },
    {
      id: 2,
      name: '2025年度碳排放中期核算报告',
      year: 2025,
      standard: 'ISO 14064-1',
      boundaryVersion: 'V2025.1',
      totalEmission: 6850.4200,
      status: 'reviewing',
      statusLabel: '待审核',
      createTime: '2025-06-20 14:00:00',
      scopeBreakdown: [
        { scope: 'Scope 1', emission: 3700.0000, ratio: 54.01 },
        { scope: 'Scope 2', emission: 3000.4200, ratio: 43.80 },
        { scope: 'Scope 3', emission: 150.0000, ratio: 2.19 }
      ],
      topSources: [
        { name: '净购入电力', emission: 2100.0000, ratio: 30.65 },
        { name: '天然气锅炉燃烧', emission: 1600.0000, ratio: 23.36 },
        { name: '煤炭燃烧', emission: 1400.0000, ratio: 20.44 }
      ]
    },
    {
      id: 3,
      name: '2024年度温室气体排放盘查报告',
      year: 2024,
      standard: 'GB/T 32150',
      boundaryVersion: 'V2024.2',
      totalEmission: 13897.8659,
      status: 'published',
      statusLabel: '已发布',
      createTime: '2024-04-10 09:00:00',
      scopeBreakdown: [
        { scope: 'Scope 1', emission: 7500.3200, ratio: 53.97 },
        { scope: 'Scope 2', emission: 6000.5459, ratio: 43.17 },
        { scope: 'Scope 3', emission: 397.0000, ratio: 2.86 }
      ],
      topSources: [
        { name: '净购入电力', emission: 4200.0000, ratio: 30.22 },
        { name: '煤炭燃烧', emission: 2800.0000, ratio: 20.15 },
        { name: '天然气锅炉燃烧', emission: 3200.0000, ratio: 23.03 }
      ]
    },
    {
      id: 4,
      name: '2025年度Scope 1专项报告',
      year: 2025,
      standard: 'GHG Protocol',
      boundaryVersion: 'V2025.1',
      totalEmission: 7500.3200,
      status: 'drafting',
      statusLabel: '编制中',
      createTime: '2025-07-01 16:20:00',
      scopeBreakdown: [
        { scope: 'Scope 1', emission: 7500.3200, ratio: 100 }
      ],
      topSources: [
        { name: '天然气锅炉燃烧', emission: 3200.0000, ratio: 42.67 },
        { name: '煤炭燃烧', emission: 2800.0000, ratio: 37.33 },
        { name: '工业过程排放', emission: 1500.3200, ratio: 20.00 }
      ]
    },
    {
      id: 5,
      name: '2025年度碳排放报告（草稿）',
      year: 2025,
      standard: 'GB/T 32150',
      boundaryVersion: 'V2025.2',
      totalEmission: 0,
      status: 'draft',
      statusLabel: '草稿',
      createTime: '2025-07-05 11:00:00',
      scopeBreakdown: [],
      topSources: []
    }
  ]

  const filtered = reports.filter(item => {
    if (year && String(item.year) !== String(year)) return false
    if (standard && item.standard !== standard) return false
    if (status && item.status !== status) return false
    return true
  })

  const statusDist = [
    { name: '已发布', value: reports.filter(r => r.status === 'published').length },
    { name: '待审核', value: reports.filter(r => r.status === 'reviewing').length },
    { name: '编制中', value: reports.filter(r => r.status === 'drafting').length },
    { name: '草稿', value: reports.filter(r => r.status === 'draft').length }
  ]

  return mockResponse({
    standards: STANDARDS,
    statusOptions: [
      { value: 'draft', label: '草稿' },
      { value: 'drafting', label: '编制中' },
      { value: 'reviewing', label: '待审核' },
      { value: 'published', label: '已发布' }
    ],
    summary: {
      total: { today: reports.length, annual: reports.length, unit: '份' },
      drafting: { today: reports.filter(r => r.status === 'drafting' || r.status === 'draft').length, annual: 2, unit: '份' },
      published: { today: reports.filter(r => r.status === 'published').length, annual: 2, unit: '份' },
      totalEmission: { today: 13897.8659, annual: 13897.8659, unit: 'tCO2e' }
    },
    scopeShare: [
      { name: 'Scope 1', value: 7500.32 },
      { name: 'Scope 2', value: 6000.55 },
      { name: 'Scope 3', value: 397.00 }
    ],
    statusDist,
    reports: filtered
  })
}

export function getEvaluationData(params = {}) {
  const year = params.year || ''
  const evalType = params.evalType || ''
  const result = params.result || ''

  const evaluations = [
    {
      id: 1,
      reportName: '2024年度温室气体排放盘查报告',
      reportYear: 2024,
      evalType: 'third_party',
      evalTypeLabel: '第三方核查',
      evaluator: 'XX认证中心',
      score: 92,
      result: 'passed',
      resultLabel: '通过',
      evalDate: '2024-06-15',
      status: 'completed',
      statusLabel: '已完成',
      checklist: ['组织边界确定合理', '排放源识别完整', '活动数据可追溯', '排放因子选用恰当', '计算过程无误'],
      dataQuality: 'A',
      conclusion: 'passed',
      remarks: '报告符合 GB/T 32150 要求，建议加强 Scope 3 数据收集。'
    },
    {
      id: 2,
      reportName: '2025年度温室气体排放盘查报告',
      reportYear: 2025,
      evalType: 'internal',
      evalTypeLabel: '内部评审',
      evaluator: '碳管理办公室',
      score: 88,
      result: 'conditional',
      resultLabel: '有条件通过',
      evalDate: '2025-04-20',
      status: 'completed',
      statusLabel: '已完成',
      checklist: ['组织边界确定合理', '排放源识别完整', '活动数据可追溯', '排放因子选用恰当'],
      dataQuality: 'B',
      conclusion: 'conditional',
      remarks: 'Scope 3 员工通勤数据需补充完善后正式发布。'
    },
    {
      id: 3,
      reportName: '2025年度碳排放中期核算报告',
      reportYear: 2025,
      evalType: 'internal',
      evalTypeLabel: '内部评审',
      evaluator: '质量管理部',
      score: 0,
      result: 'pending',
      resultLabel: '待评价',
      evalDate: '',
      status: 'pending',
      statusLabel: '待评价',
      checklist: [],
      dataQuality: '',
      conclusion: '',
      remarks: ''
    },
    {
      id: 4,
      reportName: '2023年度温室气体排放盘查报告',
      reportYear: 2023,
      evalType: 'third_party',
      evalTypeLabel: '第三方核查',
      evaluator: 'YY检测认证',
      score: 75,
      result: 'rectify',
      resultLabel: '需整改',
      evalDate: '2023-07-10',
      status: 'completed',
      statusLabel: '已完成',
      checklist: ['组织边界确定合理', '排放源识别完整'],
      dataQuality: 'C',
      conclusion: 'rectify',
      remarks: '过程排放活动水平数据缺少原始凭证，需补充后重新提交。'
    }
  ]

  const filtered = evaluations.filter(item => {
    if (year && String(item.reportYear) !== String(year)) return false
    if (evalType && item.evalType !== evalType) return false
    if (result && item.result !== result) return false
    return true
  })

  const resultDist = [
    { name: '通过', value: evaluations.filter(e => e.result === 'passed').length },
    { name: '有条件通过', value: evaluations.filter(e => e.result === 'conditional').length },
    { name: '需整改', value: evaluations.filter(e => e.result === 'rectify').length },
    { name: '待评价', value: evaluations.filter(e => e.result === 'pending').length }
  ]

  return mockResponse({
    evalTypes: [
      { value: 'internal', label: '内部评审' },
      { value: 'third_party', label: '第三方核查' }
    ],
    resultOptions: [
      { value: 'pending', label: '待评价' },
      { value: 'passed', label: '通过' },
      { value: 'conditional', label: '有条件通过' },
      { value: 'rectify', label: '需整改' }
    ],
    checklistOptions: [
      '组织边界确定合理',
      '排放源识别完整',
      '活动数据可追溯',
      '排放因子选用恰当',
      '计算过程无误',
      '不确定性分析充分'
    ],
    dataQualityOptions: ['A', 'B', 'C', 'D'],
    summary: {
      pending: { today: evaluations.filter(e => e.result === 'pending').length, annual: 1, unit: '份' },
      passed: { today: evaluations.filter(e => e.result === 'passed' || e.result === 'conditional').length, annual: 2, unit: '份' },
      rectify: { today: evaluations.filter(e => e.result === 'rectify').length, annual: 1, unit: '份' }
    },
    resultDist,
    evaluations: filtered,
    availableReports: [
      { id: 2, name: '2025年度碳排放中期核算报告' },
      { id: 5, name: '2025年度碳排放报告（草稿）' }
    ]
  })
}
